/**
 * Watches a window opened with window.open and executes the callback
 * when it's closed by the user.
 *
 * @param win - The child window to watch
 * @param callback - Called with `true` when window closes, `false` on timeout
 * @param timeout - Maximum time to wait in ms (default: 10 minutes)
 */
export function onChildWindowClose(
   win: Window | null,
   callback: (closed: boolean) => void,
   timeout?: number
): void {
   // Default to timeout = 10 minutes
   timeout = timeout || 600_000;
   const start = Date.now();
   const windowChecker = setInterval(() => {
      if (win && win.closed) {
         clearInterval(windowChecker);
         callback(true);
      } else if (Date.now() - start > timeout!) {
         clearInterval(windowChecker);
         callback(false);
      }
   }, 250);
}
